import type React from "react";
import { useDiaries } from "@/hooks/useDiaries";

const RecentDiaries: React.FC = () => {
	const { diaries, loading, error } = useDiaries();

	if (loading) return <p>読み込み中...</p>;
	if (error) return <p>エラーが発生しました: {error.message}</p>;

	return (
		<ul className="space-y-2">
			{diaries.slice(0, 3).map((diary) => (
				<li key={diary.id} className="text-sm">
					<span className="font-semibold">{diary.title}: </span>
					{diary.content.substring(0, 50)}...
				</li>
			))}
		</ul>
	);
};

export default RecentDiaries;
